import Breadcrumb from "../utlis/Breadcrumb";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import HeadingPage from "../utlis/HeadingPage";
function Promotion() {
  return (
    <>
      {/* ================= HEADER ================= */}
      <Header />

      {/* ================= BREADCRUMB / INNER SLIDER ================= */}
      <div className="InnerSld">
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="Examination & Promotion"
          title2=""
          parentTitle="Academic"
          path="Examination & Promotion"
        />
      </div>

      {/* ================= ABOUT CONTENT ================= */}
      <div className="innerbody">
        <div className="container-fluid">
          <div className="contact-form-card manage">
            <h2 className="about-title">Examination & Promotion</h2>

            <div className="about-content-card">
              <div className="affiliation-list mt-3">
                <div className="affiliation-item">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Examination and unit tests are held as indicated in the
                    school calendar. Promotions are granted on the basis of the
                    whole year’s performance. Hence, due attention would be
                    given to regular work and attendance.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    No child should be absent himself/herself on the previous
                    day of the examination.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    A student who misses an examination for any reason
                    whatsoever will not be re-examined.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Students who have not paid their dues will not be permitted
                    to appear for examination.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    A minimum attendance of 80% will be required for promotion.
                    Otherwise, the ward will be detained.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    A student caught copying or using other unfair means will
                    not be allowed to take a subsequent examination until the
                    Principal grants him/her written permission. Such students
                    are liable to be detained.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    In order to be promoted, a student should secure a minimum
                    of 40% marks. In all questions of promotion or detention,
                    the decision of the Principal is final.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    All provisions for concessions of a student who fails in any
                    class are automatically cancelled at the end of the year.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Progress reports showing the performance of the pupils and
                    their results will be given to the parents after every
                    Terminal Examination. Parents are requested to examine them
                    carefully and see that their son/daughter makes special
                    effort to study those subjects in which they are weak.
                    Application to the Principal for verification of marks in
                    special cases must be made by the parents within three days
                    of receiving the reports, together with a fee of Rs. 100/-
                    per subject for re-evaluation of Classes VII to XII, except
                    the Annual Examination.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Answer scripts of the 1st Terminal Examination of Classes
                    III to VI will be shown to the parents only on request
                    through a written application on the given date, along with
                    Classes I & II only. In any case, report cards and answer
                    scripts will not be issued to anybody other than the
                    parents.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    A student is required to pass all Unit Tests and assignments
                    by securing a minimum of 40% marks, and also secure a
                    minimum of 40% marks separately in the Annual Examination.
                    It is necessary to secure a minimum of 40% in aggregate. All
                    promotions will not be granted to students of any class who
                    fail to meet these requirements.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Continuous and comprehensive assessment shall be carried
                    out. Timely reminders, warnings and counselling with parents
                    and students shall be arranged for the improvement of slow
                    learners and problem students.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Failure in any subject or absence from regular examinations
                    excludes a pupil from being considered for the merit list
                    and promotion.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Students who fail twice in the same class shall be asked to
                    leave the school.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= FOOTER ================= */}
      <Footer />
    </>
  );
}

export default Promotion;
